import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


// JWT helpers (local to LoginPage.js)
function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

function extractRoleFromClaims(claims) {
  if (!claims) return "";
  const r1 = claims.role;
  const r2 = Array.isArray(claims.roles) && claims.roles.length ? claims.roles[0] : "";
  const r3 =
    (Array.isArray(claims["https://roles"]) && claims["https://roles"][0]) ||
    claims["https://aegis/role"];
  const flag = claims.is_admin ? "admin" : "";
  const raw = r1 || r2 || r3 || flag || "";
  return String(raw).toLowerCase();
}


export default function LoginPage({ setToken, setUser }) {
  const [email, setEmail] = useState("admin@example.com");
  const [password, setPassword] = useState("test123");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  const apiUrl = (p) => (API_BASE ? `${API_BASE}${p}` : p);

  const login = async () => {
    setError("");
    try {
      const res = await fetch(apiUrl("/api/login"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        let errMsg = "Login failed";
        try {
          const err = await res.json();
          errMsg = err.error || err.message || errMsg;
        } catch {}
        setError(errMsg);
        return;
      }

const data = await res.json();

// persist token
setToken?.(data.token);
localStorage.setItem("token", data.token);

// get base user (from response or /api/me)
let u = data.user || null;
if (!u) {
  try {
    const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
    const url = API_BASE ? `${API_BASE}/api/me` : "/api/me";
    const meRes = await fetch(url, { headers: { Authorization: `Bearer ${data.token}` } });
    if (meRes.ok) u = await meRes.json();
  } catch {}
}

// enrich with role from JWT claims if backend didn't include it
const claims = parseJwt(data.token) || {};
const role =
  (u && (u.role || (Array.isArray(u.roles) && u.roles[0]) || (u.is_admin && "admin"))) ||
  extractRoleFromClaims(claims) ||
  "";

const enriched = u ? { ...u, role: role || u.role, claims } : { role, claims };

// persist user
localStorage.setItem("user", JSON.stringify(enriched));
setUser?.(enriched);

// proceed
navigate("/dashboard");




    } catch (e) {
      setError("Network error. Please try again.");
    }
  };

  return (
    <div className="login-card">
      <h2>Welcome back</h2>
      <p style={{ color: "var(--muted)", marginTop: -6 }}>Sign in to manage Aegis Core</p>

      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        className="form-control mb-2"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        className="form-control mb-3"
      />

      <button onClick={login} className="btn btn-primary w-100">
        Login
      </button>

      {error && <p style={{ color: "#ffb6b6", marginTop: "1rem" }}>{error}</p>}
    </div>
  );
}

